<template>
  <nav class="nav-footer">
    <FooterLink
      v-for="link of currentLinks"
      :key="link.title"
      :title="link.title"
      :label="link.label"
      :param="link.param"
      :query="link.query"
    />
  </nav>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import FooterLink from "../atoms/FooterLink.vue";

const props = defineProps({
  currentPage: String,
  allLinks: {
    type: Array,
    default: () => [],
  },
  currentCaseStudy: String,
  caseStudies: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();

const currentPageLinks = computed(() => {
  const currentPageIndex = props.allLinks.indexOf(props.currentPage);
  const prevPage = props.allLinks[currentPageIndex - 1];
  const nextPage = props.allLinks[currentPageIndex + 1] || props.allLinks[1];

  return [
    {
      param: prevPage,
      title: t("footer.navLabels.prev"),
      label: t(`navigation.${prevPage}`),
    },
    {
      param: nextPage,
      title: t("footer.navLabels.next"),
      label: t(`navigation.${nextPage}`),
    },
  ];
});

const currentCaseStudyLinks = computed(() => {
  const currentIndex = props.caseStudies.indexOf(props.currentCaseStudy);
  const prev = props.caseStudies[currentIndex - 1] || props.caseStudies[props.caseStudies.length - 1];
  const next = props.caseStudies[currentIndex + 1] || props.caseStudies[0];

  return [
    {
      query: prev,
      param: null,
      title: t("footer.navLabels.prev"),
      label: t(`navigationCaseStudies.${prev}`),
    },
    {
      query: next,
      param: null,
      title: t("footer.navLabels.next"),
      label: t(`navigationCaseStudies.${next}`),
    },
  ];
})

const currentLinks = props.currentCaseStudy ? currentCaseStudyLinks : currentPageLinks
</script>

<style lang="scss" scoped>
.nav-footer {
  background-color: var(--background-base);
  color: var(--color-text-weaker);
  border-bottom: 1px solid var(--color-text-weaker);
  display: flex;

  .desktop &,
  .large & {
    padding: 1.5rem var(--page-padding-h);
  }

  .mobile &,
  .tablet & {
    flex-direction: column;
  }
}
</style>
